
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shelf/create",
      function () {
        return require("private-next-pages/shelf/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shelf/create"])
      });
    }
  